import React from 'react';
import { Button, DialogActions, Tooltip, useMediaQuery, useTheme } from '@mui/material';
import { isReseller } from '../../Utils/account.utils';
import useGentian from '../../core/hooks/useGentian';

export interface ProjectDialogFooterProps {
  onClose: () => void;
  onContinue: () => void;
  onBuyNow: () => void;
  disabled: boolean;
  text: string;
  isInstantHabMap: boolean;
  isProjectNameValid: boolean;
}

export const ProjectDialogFooter: React.FC<ProjectDialogFooterProps> = ({
  onClose,
  onContinue,
  onBuyNow,
  disabled,
  text,
  isInstantHabMap,
  isProjectNameValid,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { data: accountData } = useGentian().useAccount();
  const isResellerAccount = isReseller(accountData);

  return (
    <DialogActions sx={{ p: 0, gap: '8px' }}>
      <Button
        variant="outlined"
        color="primary"
        onClick={onClose}
        sx={{
          color: 'var(--gentian-black)',
          borderColor: 'var(--gentian-black)',
          '&:hover': {
            backgroundColor: 'var(--sundrop-yellow)',
            borderColor: 'var(--gentian-black)',
          },
        }}
      >
        Cancel
      </Button>
      {isInstantHabMap ? (
        <Button
          id="map-checkout-button"
          variant="contained"
          onClick={onBuyNow}
          disabled={disabled || !isProjectNameValid || isResellerAccount}
          sx={{
            textWrap: 'nowrap',
            flex: 1,
            minWidth: '105px',
            textAlign: 'center',
            display: { xs: 'none', sm: 'flex' },
            backgroundColor: 'var(--gentian-blue)', // Set the background color to --sundrop-yellow
            color: 'var(--gentian-white)', // Set the text color to --gentian-black for contrast
            '&:hover': {
              backgroundColor: 'var(--eclipse-black)',
            },
          }}
        >
          BUY NOW
        </Button>
      ) : (
        <Tooltip title={text}>
          <span>
            <Button
              variant="contained"
              color="primary"
              disabled={disabled}
              onClick={onContinue}
              sx={{
                textWrap: 'nowrap',
                flex: 1,
                minWidth: '105px',
                textAlign: 'center',
                display: { xs: 'none', sm: 'flex' },
                backgroundColor: 'var(--gentian-blue)', // Set the background color to --sundrop-yellow
                color: 'var(--gentian-white)', // Set the text color to --gentian-black for contrast
                '&:hover': {
                  backgroundColor: 'var(--eclipse-black)',
                },
              }}
            >
              {isMobile ? 'Submit' : 'Submit NOW'}
            </Button>
          </span>
        </Tooltip>
      )}
    </DialogActions>
  );
};
